import { request } from '@/utils/request'

export function createDataset(data) {
  return request({
    url: '/api/ai/dataset/save',
    method: 'post',
    data
  })
}

export function createDocument(data) {
  return request({
    url: '/api/ai/document/create',
    method: 'post',
    data
  })
}

export function updataDocument(data) {
  return request({
    url: '/api/ai/document/update',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 知识库列表
export function getKnowledgeBaseList(data) {
  return request({
    url: '/api/ai/dataset/list',
    method: 'post',
    data
  })
}

// 设置知识库状态
export function setKnowledgeBaseStatus(data) {
  return request({
    url: '/api/ai/dataset/set-status',
    method: 'post',
    data
  })
}

// 知识库文档列表
export function getKnowledgeBaseFileList(data) {
  return request({
    url: '/api/ai/document/list',
    method: 'post',
    data
  })
}

// 知识库详情
export function getDatasetDetail(params) {
  return request({
    url: '/api/ai/dataset/detail',
    method: 'get',
    params
  })
}

// 知识库删除
export function deleteDataset(data) {
  return request({
    url: '/api/ai/dataset/delete',
    method: 'post',
    data
  })
}

// 知识库文档删除'
export function deleteDocument(data) {
  return request({
    url: '/api/ai/document/delete',
    method: 'post',
    data
  })
}

// 设置文档状态
export function setDocumentStatus(data) {
  return request({
    url: '/api/ai/document/set-status',
    method: 'post',
    data
  })
}

// 文件名检查
export function checkFileName(params) {
  return request({
    url: '/api/ai/document/check-name',
    method: 'get',
    params
  })
}

// 文档重命名
export function renameDocument(data) {
  return request({
    url: '/api/ai/document/rename',
    method: 'post',
    data
  })
}

// 文档详情
export function getDocumentDetail(params) {
  return request({
    url: '/api/ai/document/detail',
    method: 'get',
    params
  })
}
